'use client';

import Grid from '@mui/material/Grid';
import { ListingCardSkeleton } from '@/components/Skeletons/ListingCardSkeleton';

export const ListingCardsSkeleton = ({ hitsPerPage }: { hitsPerPage: number }) => {
  return Array.from({ length: hitsPerPage }).map((_, index) => (
    <Grid size={{ mobile: 2, desktop: 3, smallTablet: 4 }} key={index}>
      <ListingCardSkeleton />
    </Grid>
  ));
};
